import { DownloadableAssetFile } from "@shared/ui/DownloadableAssetFile";
import { WorkbookData } from "@platform/types/dashboard.types";
import { ProgramResourcesSection } from "../ProgramResourcesSection/ProgramResourcesSection";

export type Props = {
  data?: WorkbookData;
};

export function ProgramWorkbookDownload({ data }: Props) {
  if (!data) return null;

  return (
    <ProgramResourcesSection
      title="Pollinator Workbook"
      description="Download the workbook for the 2025 cycle."
      className="mb-16"
    >
      <div className="w-full">
        <DownloadableAssetFile
          file={data?.file || { name: "", type: "", size: "", downloadUrl: "" }}
        />
      </div>
    </ProgramResourcesSection>
  );
}

export default ProgramWorkbookDownload;
